import EMPTY_CAMPAIGN_GROUP_TEMPLATE_ILLUSTRATION from './assets/images/empty-campaign-group-template-illustration.png';
import EMPTY_PAGE_LISTING_ILLUSTRATION from './assets/images/empty-page-listing-illustration.png';
import EMPTY_CAMPAIGN_GROUP_TEMPLATE from './assets/images/empty-campaign-group-template.png';
import EMPTY_PAGE_LISTING from './assets/images/empty-page-listing.png';
import EMPTY_ANALYTICS from './assets/images/empty-analytics.png';

import type { IGFeatureLockedData } from './types';

import { IGFeatureLocked } from './types';

export const G_FEATURE_LOCKED_DATA: Record<IGFeatureLocked, IGFeatureLockedData> = {
  [IGFeatureLocked.CampaignGroupTemplate]: {
    background: EMPTY_CAMPAIGN_GROUP_TEMPLATE,
    illustration: EMPTY_CAMPAIGN_GROUP_TEMPLATE_ILLUSTRATION,
    aspectRatio: 1152 / 521,
    maxDescriptionWidth: '330px',
  },
  [IGFeatureLocked.PageListing]: {
    background: EMPTY_PAGE_LISTING,
    illustration: EMPTY_PAGE_LISTING_ILLUSTRATION,
    aspectRatio: 1157 / 668,
    maxDescriptionWidth: '365px',
  },
  [IGFeatureLocked.Analytics]: {
    background: EMPTY_ANALYTICS,
    aspectRatio: 1150 / 573,
  },
  [IGFeatureLocked.PathAnalysis]: {
    backgroundColor: '#FFFFFFCC',
    backdropFilter: 5,
    gradientBackground:
      'radial-gradient(50% 50% at 50% 50%, #FFFFFF 55.77%, rgba(255, 255, 255, 0) 100%)',
  },
};
